export const MANUAL_REFERENCE_LANGUAGE = 'fr'

function displayedLanguageName(iso, locale) {
  if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') {
    return null
  }

  try {
    return (
      new Intl.DisplayNames([locale], {
        type: 'language',
        fallback: 'none',
      }).of(iso) || null
    )
  } catch (error) {
    return null
  }
}

export function languageName(iso, locale, locales = []) {
  const displayed = displayedLanguageName(iso, locale)

  if (displayed) return displayed

  const found = locales.find(candidate => candidate.code === iso)

  return found ? found.name : iso.toUpperCase()
}

export function manualLanguageMention(documentation, locale, locales = []) {
  if (!documentation?.isManual) return null

  const iso = documentation.language || MANUAL_REFERENCE_LANGUAGE

  if (iso === locale) return null

  return languageName(iso, locale, locales)
}

export function singleDocumentationLanguageMention(
  documentations,
  locale,
  locales = []
) {
  if (documentations?.length !== 1) return null

  return manualLanguageMention(documentations[0], locale, locales)
}
